import { useQuery } from "@tanstack/react-query";
import { getReportsDashboard } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

export default function useDashboardReports(params = { period: "30d" }) {
  const {
    data,
    error,
    isLoading,
    refetch: refreshDashboard
  } = useQuery({
    queryKey: ["dashboardReports", params], 
    queryFn: async () => {
      try {
        const response = await getReportsDashboard(params);
        return response;
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    enabled: true,
    staleTime: 1000 * 60 * 60, 
    cacheTime: 1000 * 60 * 60 * 12, 
    refetchOnWindowFocus: false,
  });

  const lastUpdated = data?.meta?.generated_at
    ? new Date(data.meta.generated_at)
    : data
    ? new Date()
    : null;

  return {
    data: data?.data ?? null,
    loading: isLoading,
    error,
    refreshDashboard,
    lastUpdated,
  };
}













































































